import { CURRENCY_OPTIONS } from '@/lib/constants';
import {
  NativeSelect,
  NativeSelectProps,
  TextInput,
  TextInputProps,
} from '@mantine/core';

export function PriceInput(
  props: TextInputProps & {
    currencyProps: NativeSelectProps;
    currencyLocked?: boolean;
  },
) {
  const { currencyLocked = false, currencyProps, ...textInputProps } = props;
  const { key, ...restOfCurrencyProps } = currencyProps;

  const select = (
    <NativeSelect
      data={CURRENCY_OPTIONS.filter((pair) => !pair.label.includes('GBP'))}
      rightSectionWidth={28}
      disabled={currencyLocked}
      size="xs"
      key={key}
      styles={{
        input: {
          fontWeight: 500,
          borderTopLeftRadius: 0,
          borderBottomLeftRadius: 0,
          width: 75,
          marginRight: -2,
        },
      }}
      {...restOfCurrencyProps}
    />
  );

  return (
    <TextInput
      size={'xs'}
      min={0}
      type="number"
      placeholder="999.99"
      rightSection={select}
      rightSectionWidth={75}
      onFocus={(e) => {
        e.target.select();
      }}
      {...textInputProps}
    />
  );
}
